/** Mirror of `socaity_schemas.platform.project`. */

import { CatalogJob } from './job';

export class Project {
  id: string | null;
  display_name: string | null;
  description: string | null;
  created_by: string | null;
  created_at: string | null;
  n_jobs: number | null;
  n_files: number | null;
  jobs: CatalogJob[];

  constructor(data: Record<string, any> = {}) {
    this.id = data.id ?? null;
    this.display_name = data.display_name ?? null;
    this.description = data.description ?? null;
    this.created_by = data.created_by ?? data.user_id ?? null;
    this.created_at = data.created_at ?? null;
    this.n_jobs = data.n_jobs ?? 0;
    this.n_files = data.n_files ?? data.n_assets ?? 0;
    this.jobs = Array.isArray(data.jobs) ? data.jobs.map((j: any) => new CatalogJob(j)) : [];
  }
}

/** @deprecated Prefer `Project`. Kept for existing warehouse mapping. */
export function createUserProject(data: Record<string, any> = {}) {
  return {
    id: data.id || null,
    display_name: data.display_name || null,
    description: data.description || null,
    created_at: data.created_at || null,
    user_id: data.user_id || data.created_by || null,
    n_jobs: data.n_jobs ?? 0,
    n_files: data.n_files ?? data.n_assets ?? 0,
  };
}
